const getInningsData = (data, inningsSelected) => {
  if (!inningsSelected || !data.innings) return null;
  const inningsData = data.innings.find((el) => {
    return el.innings_number === inningsSelected.toString();
  });
  return inningsData;
};

export default getInningsData;
